import { createReducer, createActions } from 'reduxsauce'

// Initial State
export const initialState = {
    phase: null,
    totalSeasons: 1,
    totalRaces: 1,
    season: 1,
    race: 1,
    credits: 0,
    remainingSeconds: 0,
    finished: false,
    data: {}
}

// Types and Action Creators
const { Types, Creators } = createActions(
    {
        clean: null,
        setState: ['newState'],
        setFinished: ['finished'],
        // Sagas
        onPhaseUpdated: ['response']
    },
    {
        prefix: 'PHASE_INFO_'
    }
)

export const PhaseInfoTypes = Types

// Reducers and Handlers
export const handlers = {
    [Types.CLEAN]: () => ({ ...initialState }),
    [Types.SET_STATE]: (state = initialState, { newState }) => ({ ...state, ...newState }),
    [Types.SET_FINISHED]: (state = initialState, { finished }) => ({ ...state, finished })
}

export const reducer = createReducer(initialState, handlers)

export default Creators



// WEBPACK FOOTER //
// src/store/redux/phaseInfo.js